/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
import {IHttpService, ILogService, IPromise, IQService} from 'angular';
import {TSRole} from '../../models/enums/TSRole';
import TSBenutzer from '../../models/TSBenutzer';
import IRequestShortcutConfig = angular.IRequestShortcutConfig;
import IRootScopeService = angular.IRootScopeService;

/**
 * Service zum verwalten von Fondssuisse.
 */
export default class FondssuisseRS {

    static $inject = ['$http', 'CONSTANTS', '$q', '$rootScope', '$log'];

    /* @ngInject */
    constructor(private $http: IHttpService, private CONSTANTS: any, private $q: IQService,
                private $rootScope: IRootScopeService, private $log: ILogService) {
    }

    public getBenutzerOfFondssuisse(roleToLimitTo?: TSRole): IPromise<Array<TSBenutzer>> {
        let configObject: IRequestShortcutConfig;
        if (roleToLimitTo === undefined) {
            configObject = {
                params: {
                    rolesToLimitTo: [TSRole[TSRole.FONDSSUISSE_SACHBEARBEITER], TSRole[TSRole.FONDSSUISSE_ADMIN]]
                }
            }
        } else {
            configObject = {
                params: {
                    rolesToLimitTo: [TSRole[roleToLimitTo]]
                }
            }
        }
        return this.$http.get(this.CONSTANTS.REST_API + 'fondssuisse/benutzer',
            configObject)
            .then((response) => {
                if (response.data !== undefined) {
                    this.$log.debug('PARSING Benutzer REST  object', response.data);
                    return TSBenutzer.deserializeArray(response.data);
                } else {
                    return [];
                }
            })
    }

    public addFSSachbearbeiterRole(benutzerId: string): IPromise<TSBenutzer | undefined> {
        return this.$http.put(this.CONSTANTS.REST_API + 'fondssuisse/benutzer/sachbearbeiter/' + encodeURIComponent(benutzerId), undefined)
            .then((response) => {
                if (response.data !== undefined && response.data !== null && response.data !== '') {
                    this.$log.debug('added role to benutzer ', response.data);
                    return TSBenutzer.getDeserializer(response.data);

                } else {
                    this.$log.debug('role was already present on benutzer ', benutzerId);
                    return undefined;
                }
            });

    }

    public addFSAdminRole(benutzerId: string): IPromise<TSBenutzer | undefined> {
        return this.$http.put(this.CONSTANTS.REST_API + 'fondssuisse/benutzer/admin/' + encodeURIComponent(benutzerId), undefined)
            .then((response) => {
                if (response.data !== undefined && response.data !== null && response.data !== '') {
                    this.$log.debug('added role to benutzer ', response.data);
                    return TSBenutzer.getDeserializer(response.data);

                } else {
                    this.$log.debug('role was already present on benutzer ', benutzerId);
                    return undefined;
                }
            });

    }

    public removeFSSachbearbeiterRole(benutzerId: string): IPromise<void> {
        return this.$http.delete(this.CONSTANTS.REST_API + 'fondssuisse/benutzer/sachbearbeiter/' + encodeURIComponent(benutzerId))
            .then((response) => {
                if (response.data !== undefined) {
                    this.$log.debug('removed role from benutzer ' + benutzerId);

                }
            });

    }

    public removeFSAdminRole(benutzerId: string): IPromise<void> {
        return this.$http.delete(this.CONSTANTS.REST_API + 'fondssuisse/benutzer/admin/' + encodeURIComponent(benutzerId))
            .then((response) => {
                if (response.data !== undefined) {
                    this.$log.debug('removed FS_ADMIN role from benutzer');

                }
            });

    }
}



// WEBPACK FOOTER //
// ./src/app/core/service/FondssuisseRS.rest.ts